'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var replaceInTemplate = require('../string/replace-in-template.js');
var constants = require('./constants.js');
var convert = require('./convert.js');

const defaultLocaleLabels = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
const defaultEnglishTemplate = {
    timeTemplate: '%time% %timeLabel% ago',
    fullDateTemplate: 'on %date%',
    monthLocaleLabels: defaultLocaleLabels,
    timeLabel: {
        minute: {
            singular: 'min',
            plural: 'min',
        },
        hour: {
            singular: 'hour',
            plural: 'hours',
        },
    },
};
const TEMPLATE_CONFIG = {
    delimiter: {
        left: '%',
        right: '%',
    },
};
const formatMinuteString = (minute) => {
    const str = minute.toString();
    return {
        time: str.length === 2 ? str : `0${str}`,
    };
};
const formatHourString = (hour) => {
    const period = hour < 12 ? 'am' : 'pm';
    const twelveHourTime = hour > 12 ? hour - 12 : hour;
    return {
        time: twelveHourTime === 0 ? '12' : twelveHourTime.toString(),
        period,
    };
};
const getTemplatingParameters = (msDiff, config) => {
    const { dates, templateConfig } = config;
    const { timeLabel, monthLocaleLabels, timeTemplate, fullDateTemplate } = templateConfig;
    if (msDiff < constants.MS_HOUR) {
        const minuteDiff = convert.msToMinute(msDiff);
        const minuteUnit = minuteDiff > 1
            ? timeLabel.minute.plural
            : timeLabel.minute.singular;
        return {
            template: timeTemplate,
            params: {
                time: String(minuteDiff || 1),
                timeLabel: minuteUnit,
            },
        };
    }
    if (msDiff < constants.MS_DAY) {
        const hourDiff = convert.msToHour(msDiff);
        const hourUnit = hourDiff > 1
            ? timeLabel.hour.plural
            : timeLabel.hour.singular;
        return {
            template: timeTemplate,
            params: {
                time: String(hourDiff),
                timeLabel: hourUnit,
            },
        };
    }
    const monthLabel = monthLocaleLabels[dates.old.getMonth()];
    const minute = formatMinuteString(dates.old.getMinutes());
    const hour = formatHourString(dates.old.getHours());
    const dayFormat = `${monthLabel} ${dates.old.getDate()}`;
    const timeFormat = `${hour.time}:${minute.time} ${hour.period}`;
    return {
        template: fullDateTemplate,
        params: {
            date: `${dayFormat}, ${timeFormat}`,
        },
    };
};
/**
 * The returned string follows the following rules:
 *  - If diff < 60 minutes: '29 min ago'
 *  - If diff >= 60 minutes & < 24 hours: '12 hours ago' | '1 hour ago'
 *  - If diff > 24 hours: 'on March 15, 14:45 pm'
 *
 * @param olderDate - Date
 * @param recentDate - Date
 * @param template - DiffTemplate
 * @returns a preformated string to be inserted in a phrase.
 */
const getTimeDiffAsString = (olderDate, recentDate = new Date(), templateConfig = defaultEnglishTemplate) => {
    const oldDateTime = olderDate.getTime();
    const recentDateTime = recentDate.getTime();
    if (oldDateTime > recentDateTime) {
        return '';
    }
    const msDiff = recentDateTime - oldDateTime;
    const { template, params } = getTemplatingParameters(msDiff, {
        dates: {
            old: olderDate,
            recent: recentDate,
        },
        templateConfig,
    });
    return replaceInTemplate.replaceInTemplate(template, params, TEMPLATE_CONFIG);
};

exports.getTimeDiffAsString = getTimeDiffAsString;
//# sourceMappingURL=get-time-diff-as-string.js.map
